import { useState, useEffect, useCallback } from "react";
import BlogCard from "./BlogCard";
import PreLoader from "./PreLoader";
import "./Blogs.css";
import Pagination from "./Pagination/Pagination";
import { Link } from "react-router-dom";

function Blogs() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    per_page: 12,
    total: 0,
    from: null,
    to: null,
  });

  const fetchBlogs = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);

    try {
      const params = new URLSearchParams({
        per_page: "12",
        page: page.toString(),
        status: "published",
      });

      const response = await fetch(
        `https://admin.360-bytes.com/api/getBlogs?${params}`
      );

      if (!response.ok) {
        throw new Error(`HTTP Error: ${response.status}`);
      }

      const result = await response.json();
      setBlogs(result.data || []);
      if (result.pagination) {
        setPagination(result.pagination);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchBlogs(1);
  }, [fetchBlogs]);

  const handlePageChange = (page) => {
    if (
      page < 1 ||
      page > pagination.last_page ||
      page === pagination.current_page ||
      loading
    ) {
      return;
    }
    fetchBlogs(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (loading && blogs.length === 0) {
    return <PreLoader content="Loading blogs..." />;
  }

  if (error && blogs.length === 0) {
    return (
      <div className="blog-state-wrapper">
        <div className="container">
          <div className="blog-state-card">
            <p>{error}</p>
            <button onClick={() => fetchBlogs(1)} className="btn-back">
              Try Again
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="blogs-page-wrapper">
      {/* Breadcrumbs Navigation */}
      <section className="hmslder-sec abt-sec blog-details-breadcrumbs">
        <div className="breadcrumbs">
          <div className="container">
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>Blogs</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Main Blog Listing Section */}
      <section className="blogs-listing-sec">
        <div className="container">
          <div className="mn-head blogs-heading-center">
            <h5>LATEST BLOGS</h5>
            <h3>Our Latest Insights</h3>
          </div>

          {blogs.length === 0 && !loading && (
            <div className="blogs-empty-state">
              <div className="blogs-empty-card">
                <h3>No blogs available</h3>
                <p>Check back soon for new articles and insights.</p>
              </div>
            </div>
          )}

          {/* 3-Column Responsive Grid Architecture (Configured for multiple blogs) */}
          {blogs.length > 0 && (
            <div className="blogs-grid">
              {blogs.map((blog, index) => (
                <BlogCard key={blog.id || blog.slug || index} blog={blog} />
              ))}
            </div>
          )}

          {/* Always Display Pagination */}
          <Pagination
            pagination={pagination}
            loading={loading}
            handlePageChange={handlePageChange}
          />
        </div>
      </section>
    </div>
  );
}

export default Blogs;